import styled from 'styled-components';
import { BreakpointsEnum } from '@app/types';

const PublicUserOffer = () => {
  return (
    <Background>
      <PublicUserOfferContent />
    </Background>
  );
};

export const PublicUserOfferContent = () => (
  <>
    <Container>
      <PageTitle>Публичная оферта для «Пользователя»</PageTitle>

      <AfterPageTitle>
        <div>г. Москва</div>
        <div>{new Date().getFullYear()} год</div>
      </AfterPageTitle>

      <Title>1. Общие положения</Title>

      <Paragraph>
        1.1. Настоящий Договор является публичной офертой на основании пункта 2
        статьи 437 Гражданского Кодекса Российской Федерации Общества с
        ограниченной ответственностью «Поговорим онлайн», в лице генерального
        директора Гайдая Виктора Александровича, действующего на основании
        устава, именуемого в дальнейшем «Исполнитель», любому правоспособному и
        дееспособному физическому лицу, достигшему 18 лет, выразившему
        готовность воспользоваться услугами Исполнителя и принявшему условия
        настоящего Договора, далее Договор, публичной оферты. После принятия
        изложенных ниже условий и началом пользования Сервисом, лицо,
        производящее акцепт этой оферты, становится Пользователем.
      </Paragraph>

      <Paragraph>
        1.2. Полным и безоговорочным акцептом настоящей публичной оферты
        считается регистрация или авторизация Пользователя на Сервисе.
      </Paragraph>

      <Paragraph>
        1.3. Публичный договор, совершенный в вышеописанном порядке, считается
        заключенным в простой письменной форме, не требует оформления на
        бумажном носителе и обладает полной юридической силой.
      </Paragraph>

      <Paragraph>
        1.4. С момента совершения акцепта Пользователь считается ознакомившимся
        и согласившимся с настоящей публичной офертой и политикой в отношении
        обработки и защиты персональных данных, размещенных на Сервисе, в
        соответствии с Гражданским Кодексом РФ, считается вступившим с
        Исполнителем в договорные отношения в соответствии с условиями Договора.
      </Paragraph>

      <Paragraph>
        1.5. Исполнитель имеет право в любой момент изменять условия
        предоставления услуг и условия Договора в одностороннем порядке без
        предварительного согласования с Пользователем, обеспечивая при этом
        публикацию измененных условий на Сервисе не позднее, чем за один день до
        их ввода в действие.
      </Paragraph>

      <Paragraph>
        1.6. В случае, если Пользователь пользуется Сервисом с целью получения
        Видеоконсультаций от Специалиста для несовершенноголетнего ребенка до 18
        лет, то с момента совершения акцепта данный Пользователь подтверждает,
        что является законным представителем данного ребенка и дает свое
        согласие на его участие в психологической работе.
      </Paragraph>

      <Title>2. Термины и определения</Title>

      <Paragraph>
        В целях Договора Стороны согласились использовать следующие термины и
        определения:
      </Paragraph>

      <Paragraph>
        2.1. «Сервис» - разработанная Исполнителем онлайн платформа (программный
        комплекс) «П о гово рим онлайн», расп ол оженная в инф о рмаци онн о –
        телекоммуникационной сети Интернет по адресам{' '}
        <a href="https://www.pogovorim.online" target="_blank" rel="noreferrer">
          https://www.pogovorim.online
        </a>{' '}
        и/или поговорим.online (параллельно паркованный домен), позволяющая
        осуществлять выбор психолога из предложенных Специалистов, а также
        проводить Видеоконсультации между Специалистом и Пользователем, а также
        обладающая другими функциональными возможностями, доступными
        Специалисту.
      </Paragraph>

      <Paragraph>
        2.2. «Видеоконсультация» – также онлайн консультация на Сервисе,
        участником которой является Специалист и Пользователь, на основе своей
        учетной записи через свой Личный кабинет, продолжительность которой
        устанавливается Сервисом, но не может быть менее 50 минут, если иное не
        установлено по договоренности между Пользователем и Специалистом внутри
        Сервиса.
      </Paragraph>

      <Paragraph>
        2.3. «Пользователь» – физическое лицо, обладающее полной право- и
        дееспособностью, достигшее 18 лет, обратившееся к Специалисту
        посредством Сервиса и пользующееся услугами Исполнителя в соответствии с
        настоящим Договором. Пользователь также может выступать законным
        представителем несовершенного ребенка до 18 лет (далее Представитель) и
        в этом случае несет полную ответственность за соблюдение правил данной
        оферты и выполнения ее условий.
      </Paragraph>

      <Paragraph>
        2.4. «Специалист» – физическое лицо, обладающее полной право- и
        дееспособностью, достигшее 18 лет, имеющее высшее образование или
        прошедшее переподготовку в области психологии, оказывающее помощь и
        консультирование Пользователей по различным вопросам (эмоциональные,
        личностные, социальные и т.п.) посредством Сервиса, без выписывания
        медицинских рецептов.
      </Paragraph>

      <Paragraph>
        2.5. «Личный кабинет» – персональная страница Пользователя на Сервисе,
        доступ к которой предоставляется Пользователю после регистрации. Логином
        для входа в Личный кабинет является телефонный номер или электронная
        почта Пользователя (далее - «логин»), а паролем – автоматически
        сгенерированный Сервисом одноразовый пароль, который направляется на
        телефонный номер или электронную почту Пользователя каждый раз в момент
        входа на Сервис (далее – «пароль»). Личный кабинет содержит анкету,
        обязательную для заполнения Пользователем.
      </Paragraph>

      <Paragraph>
        2.6. «Промокод» - определенная последовательность символов при условии
        активации которых и соблюдении иных условий использования промокода
        предоставляется скидка.
      </Paragraph>

      <Paragraph>
        2.7. Представитель – Пользователь, обратившийся к Специалисту
        посредством Сервиса в пользу несовершенноголетнего ребенка до 18 лет,
        законным представителем которого он является
      </Paragraph>

      <Title>3. Предмет Договора</Title>

      <Paragraph>
        3.1. Предметом Договора является предоставление Исполнителем
        Пользователю доступа к функциональным возможностям Сервиса, позволяющим
        осуществить выбор Специалиста, а также проведения Видеоконсультаций со
        Специалистом по вопросу индивидуальной психологиче ской работы с
        Пользователем. При этом Видеоконсультацию Пользователю проводит
        непосредственно Специалист, а Исполнитель только предоставляет
        техническую возможность использования функциональных возможностей
        Сервиса.
      </Paragraph>

      <Paragraph>
        3.1.1. Пользователь предоставляет Исполнителю право на использование
        обратной связи Пользователя для исследований и улучшения качества работы
        Сервиса, проводимых Видеоконсультаций, анализа целесообразности и
        качества используемых практических подходов в работе Сервиса. Указанное
        использование не будет являться нарушением условий конфиденциальности.
      </Paragraph>

      <Paragraph>
        3.2. Функциональные возможности Сервиса для Пользователя:
      </Paragraph>

      <Paragraph>
        3.2.1. Возможность выбора наиболее подходящих для решения вопросов
        Пользователя Специалистов. Пользователь имеет право выбрать иного
        Специалиста из всей базы специалистов, разместивших информацию о себе на
        Сервисе.
      </Paragraph>

      <Paragraph>
        3.2.2. Неограниченный доступ Пользователя к своему Личному кабинету.
      </Paragraph>

      <Paragraph>
        3.2.3. Возможность записи на Видеоконсультации согласно графику
        Специалиста.
      </Paragraph>

      <Paragraph>3.2.4. Возможность проведения Видеоконсультаций.</Paragraph>

      <Paragraph>
        3.3. Ни Исполнитель, ни Специалист не оказывают медицинские услуги, не
        занимаются выдачей каких-либо сертификатов или рецептов, а также не
        осуществляют назначение медицинских препаратов. Исполнитель и Специалист
        не занимаются лечебной или какой-либо другой медицинской практикой.
      </Paragraph>

      <Paragraph>
        3.4. Взаимодействие Исполнителя и Специалиста осуществляется в рамках
        отдельного договора, заключаемого после регистрации Специалиста на
        Сервисе. До момента заключения такого договора Специалист пользуется
        Сервисом на общих условиях, изложенных в настоящем Пользовательском
        соглашении.
      </Paragraph>

      <Paragraph>
        3.5. Пользователь полностью осознает, что Исполнитель ни при каких
        условиях не может нести и не несет ответственность за результат
        проведения Видеоконсультаций.
      </Paragraph>

      <Paragraph>
        3.6. Пользователь полностью осознает, что Исполнитель может в любой
        момент отказать в предоставлении доступа к Сервису, в случае нарушения
        Пользователем условий настоящего Договора, а также в любых иных случаях,
        в том числе, и без объяснения причин.
      </Paragraph>

      <Paragraph>
        3.7. В случае, если Пользователь пропускает Видеоконсультацию согласно
        установленному со Специалистом графику или уведомляет о переносе
        Видеоконсультации позже, чем за 24 часа до назначенного времени,
        уплаченные за Видеоконсультацию Специалисту денежные средства не
        подлежат возврату Пользователю.
      </Paragraph>

      <Paragraph>
        3.8. В случае, если Видеоконсультация не состоялась по вине Специалиста
        и/или Специалист уведомил Пользователя об отмене или переносе
        Видеоконсультации не позже чем за 24 часа, то, на усмотрение
        Пользователя, оплаченная за Видеоконсультацию сумма, либо подлежит
        возврату Пользователю, либо засчитывается в счет оплаты следующей
        Видеоконсультации.
      </Paragraph>

      <Paragraph>
        3.9. В случае, если Пользователь или Специалист опаздывает на
        назначенную Видеоконсультацию, время Видеоконсультации не продлевается,
        и действуют правила установленные пп. 3.7, 3.8 настоящей оферты.
      </Paragraph>

      <Paragraph>
        3.10. Особенностью исполнения договорных обязательств является
        отсутствие гарантированного результата, так как полезный эффект зависит
        не только от профессионализма Специалиста, но и от личных качеств
        Пользователя.
      </Paragraph>

      <Paragraph>
        3.11. Для пользования Сервисом Пользователь должен обеспечить наличие
        следующего оборудования и программного обеспечения:
        <br />
        • настольный компьютер/ноутбук;
        <br />
        • видеокамера, встроенная или внешняя;
        <br />
        • микрофон, встроенный или внешний;
        <br />
        • десктоп-версия браузера Chrome не ниже 58.0.3029, Safari не ниже
        версии 15.x, Firefox не ниже версии 100.0 и других браузеров актуальных
        версий:
        <br />• стабильный интернет-канал с входящей и исходящей скоростью не
        менее 6 мегабита в секунду в каждом направлении.
      </Paragraph>

      <Paragraph>
        3.12. Использование Сервиса осуществляется Пользователем по своему
        решению и на свой риск при условии, что Пользователь несет полную
        ответственность за любой ущерб, причиненный компьютерной системе
        Пользователя, за потерю данных или иной вред, причиненный в результате
        такой деятельности.
      </Paragraph>

      <Paragraph>
        3.13. У Исполнителя нет доступа к проводимым Видеоконсультациям.
        Функционал Сервиса не предполагает запись Видеоконсультации или их
        хранение и обработку. При этом Исполнитель имеет право обрабатывать и
        обнародовать обезличенные данные Пользователя, такие как пол, возраст,
        профессия, эмоциональное состояние и иное, в целях анализа, доработки,
        внесения изменений в Сервис, а также размещения статистических данных в
        информационно-телекоммуникационной сети «Интернет», на конференциях,
        предоставления аналитики третьим лицам, в пределах, разрешенных
        законодательством Российской Федерации, а Пользователь дает на это свое
        согласие.
      </Paragraph>

      <Paragraph>
        3.14. По устной договоренности между Специалистом и Пользователем
        Специалист может самостоятельно забронировать Видеоконсультацию для
        Пользователя в своем Личном кабинете, если выполнены следующие
        условия:
        <br />
        - Специалист уже провел для данного Пользователя одну или более
        Видеоконсультацию.
        <br />- Новая Видеоконсультация забронирована Специалистом не позднее,
        чем за 48 часов до начала Видеоконсультации.
      </Paragraph>

      <Paragraph>
        3.15. При бронировании сессии через Сервис Пользователь обязан привязать 
        банковскую карту. Только после успешного холдирования суммы бронирование
        подтверждается, и сессия считается закреплённой за Пользователем. В случае 
        отсутствия привязанной карты бронирование невозможно.
      </Paragraph>

      <Title>4. Права и обязанности Исполнителя</Title>

      <Paragraph>4.1. Исполнитель обязан:</Paragraph>

      <Paragraph>
        4.1.1. Предоставлять доступ к функциональным возможностям Сервиса в
        соответствии с условиями настоящего Договора, после регистрации
        Пользователя на Сервисе и первичного заполнения Пользователем анкеты в
        Личном кабинете.
      </Paragraph>

      <Paragraph>
        4.1.2. По запросу Пользователя давать Пользователю разъяснения по
        вопросам пользования Сервисом.
      </Paragraph>

      <Paragraph>4.2. Исполнитель вправе:</Paragraph>

      <Paragraph>
        4.2.1. Самостоятельно определять функциональные возможности Сервиса,
        изменять или вносить новые функциональные возможности Сервиса без
        предварительного согласования с Пользователем.
      </Paragraph>

      <Paragraph>
        4.2.2. Проводить на Сервисе технические работы без предварительного
        уведомления Пользователей. В случаях, когда очевидно, что технические
        работы займут более суток, Исполнитель предпринимает меры к
        предварительному уведомлению Пользователей о готовящихся работах путем
        размещения соответствующего уведомления на Сервисе.
      </Paragraph>

      <Paragraph>
        4.2.3. Требовать от Пользователя предоставления информации о его текущем
        состоянии путем заполнения анкеты в Личном кабинете.
      </Paragraph>

      <Paragraph>
        4.2.4. Отказать в доступе к Сервису по любым основаниям, в том числе без
        объяснения причин, в случае невыполнения или ненадлежащего выполнения
        Пользователем своих обязательств по Договору.
      </Paragraph>

      <Title>5. Права и обязанности Пользователя</Title>

      <Paragraph>5.1. Пользователь обязан:</Paragraph>

      <Paragraph>
        5.1.1. Предоставлять Исполнителю по запросу, а также путем заполнения
        анкеты в Личном кабинете, достоверные сведения и данные, необходимые для
        надлежащего исполнения Исполнителем своих обязательств. При заключении
        Договора Пользователь обязан зарегистрироваться на Сервисе, получить
        доступ к Личному кабинету, произвести первичное заполнение размещенной в
        нем анкеты.
      </Paragraph>

      <Paragraph>
        5.1.2. Соблюдать график Видеоконсультаций, размещенный в Личном кабинете
        и согласованный со Специалистом, о любом изменении уведомлять
        Специалиста не позднее чем за 24 часа до назначенного времени
        Видеоконсультации.
      </Paragraph>

      <Paragraph>
        5.1.3. Не вести запись аудио и Видеоконсультации, не воспроизводить, не
        копировать, не распространять, а также не использовать любым иным
        способом, в каких бы то ни было целях, содержимое Сервиса, за
        исключением личного использования в рамках настоящего Договора.
      </Paragraph>

      <Paragraph>
        5.1.4. Не осуществлять действия по размещению на Сервисе рекламной
        информации, а также любых незаконных, дискредитирующих, несущих угрозу
        сообщений или сообщений, противоречащих законодательству Российской
        Федерации.
      </Paragraph>

      <Paragraph>
        5.1.5. Не передавать логин и пароль к своему Личному кабинету любым
        третьим лицам, стремиться обеспечить секретность указанных логина и
        пароля. В случае несоблюдения указанного условия (включая случаи утечки
        информации о логине и пароле против воли Пользователя) Исполнитель не
        несет какой-либо ответственности за предоставление доступа в Личный
        кабинет Пользователя лицу, любым способом заполучившему логин и пароль
        Пользователя, за разглашение конфиденциальных данных Пользователя и не
        обязан компенсировать ущерб Пользователя, вызванный таким нарушением.
      </Paragraph>

      <Paragraph>
        5.1.6. Не осуществлять агитацию, подстрекательство Специалиста оказывать
        услуги Пользователю без использования Сервиса, не размещать на Сервисе
        информацию, каким-либо образом дискредитирующую Исполнителя и/или
        информацию несоответствующую действительности. Сообщать Исполнителю о
        любых случаях попытки Специалиста вывести Видеоконсультации за пределы
        Сервиса.
      </Paragraph>

      <Paragraph>
        5.1.7. Незамедлительно уведомить Исполнителя о случаях утери либо
        хищения логина и/или пароля к Личному кабинету Пользователя.
      </Paragraph>

      <Paragraph>
        5.1.8. Присутствовать на Видеоконсультации в здравом уме, не курить, не
        принимать алкоголь во время Видеоконсультации, не покидать её ранее
        установленного времени, без уважительной причины, а также не проводить
        Видеоконсультации в состоянии алкогольного и/или наркотического
        опьянения или под действием лекарственных препаратов, за исключением
        случаев назначения таких препаратов лечащим врачом Пользователя, о чем
        Пользователь, в обязательном порядке уведомляет Специалиста;
        информировать Специалиста об изменениях в следующих аспектах своей
        жизни: работе, образовании, отношениях с родителями, родственниками,
        близкими друзьями, мужем (женой), партнёрами; информировать Специалиста
        об изменениях в своём физическом и психологическом самочувствии.
      </Paragraph>

      <Paragraph>
        5.1.9 В случае, если Пользователь является Представителем, то он
        обязуется соблюдать все подпункты 5.1, а также:
        <br />
        • Самостоятельно начинать и завершать (при необходимости)
        Видеоконсультацию в Личном кабинете
        <br />• Присутствовать на всех Видеоконсультациях на протяжении всей ее
        продолжительности, если иное не обговорено со Специалистом
      </Paragraph>

      <Paragraph>5.2. Пользователь вправе:</Paragraph>

      <Paragraph>
        5.2.1. Получать, при необходимости, консультации Исполнителя
        относительно возможностей Сервиса.
      </Paragraph>

      <Paragraph>
        5.2.2. Выбрать Специалиста из предложенных на Сервисе и выносить на
        обсуждение, в рамках Видеоконсультации, любую интересующую Пользователя
        личную проблему.
      </Paragraph>

      <Paragraph>
        5.2.3. Отказаться в одностороннем порядке от использования Сервиса и
        расторгнуть Договор путем направления соответствующего уведомления
        Исполнителю по электронному адресу{' '}
        <a href="mailto:pogovorim.online@yandex.ru" rel="noreferrer">
          pogovorim.online@yandex.ru
        </a>{' '}
        или путем нажатия кнопки «Удалить аккаунт» в Личном кабинете, в
        результате чего Исполнитель блокирует Пользователя и удаляет записи на
        будущие Видеоконсультации из графика Специалиста. В случае такого отказа
        Договор будет считаться прекращенным со дня, следующего за днем
        получения такого уведомления Исполнителем.
      </Paragraph>

      <Paragraph>
        5.2.4. Сменить Специалиста на любом этапе, количество таких замен не
        ограничено Сервисом.
      </Paragraph>

      <Paragraph>5.2.5. Оставить отзыв о Специалисте.</Paragraph>

      <Title>6. Финансовые условия</Title>

      <Paragraph>
        6.1. Пользователь не платит за получения доступа к Сервису, однако,
        отдельные функции Сервиса могут быть платными. Оплата Пользователем
        таких функций производится посредством платежных систем, предложенных на
        Сервисе.
      </Paragraph>

      <Paragraph>
        6.2. При этом использование Сторонами определенной системы расчетов
        может быть связано с заключением указанными лицами отдельного
        соглашения, регулирующего применение соответствующей системы расчетов и
        заключение которого является обязательным условием проведения расчетов
        таким способом и в таком порядке.
      </Paragraph>

      <Paragraph>
        6.3. На сервисе действует функция безналичной оплаты с банковской карты,
        в данном случае Исполнитель действует по поручению соответствующего
        Специалиста с привлечением уполномоченного оператора по приему платежей
        и является получателем платежа в качестве агента Специалиста (далее –
        «безналичная оплата»). Исполнитель не гарантирует отсутствия ошибок и
        сбоев в работе Сервиса в отношении функции безналичной оплаты.
      </Paragraph>

      <Paragraph>
        6.4. Использование Пользователем функции безналичной оплаты является
        подтверждением того, что Пользователь ознакомлен и принимает в полном
        объеме условия партнера Исполнителя - сервиса ЮKassa, посредством
        которого происходит расчет между Специалистом и Пользователем,
        размещенными по адресу{' '}
        <a href="https://yookassa.ru/" target="_blank" rel="noreferrer">
          https://yookassa.ru/
        </a>
        .
      </Paragraph>

      <Paragraph>
        6.5. Исполнитель использует систему промокодов для предоставления скидок. 
        Условия использования промокодов размещаются на сайте Исполнителя и могут 
        изменяться Исполнителем в одностороннем порядке. Применение промокодов 
        возможно только при привязанной банковской карте.
      </Paragraph>

      <Paragraph>
        6.6. При бронировании сессий через Сервис используется привязка банковской 
        карты и холдирование средств на карте Пользователя. Привязка карты осуществляется 
        после успешной оплаты сессии через систему ЮKassa, при этом тестовое списание не 
        производится. Холдирование полной суммы происходит автоматически в момент подтверждения 
        бронирования, и Пользователь соглашается с тем, что средства могут быть списаны в случае 
        отмены сессии с нарушением установленных сроков.
      </Paragraph>

      <Title>7. Гарантии и ответственность</Title>

      <Paragraph>
        7.1. Исполнитель не оказывает медицинские услуги. Информация о здоровье
        Пользователя и его персональные данные принимаются исключительно со слов
        Пользователя, а также путем заполнения анкеты в Личном кабинете.
        Пользователь лично несет ответственность за достоверность сведений о
        своем здоровье.
      </Paragraph>

      <Paragraph>
        7.2. Личные данные Пользователя не могут быть предоставлены Исполнителем
        третьим лицам без согласия Пользователя, исключением является раскрытие
        личных данных Пользователя по запросу государственных органов,
        предоставление данных Специалисту, выбранному Пользователем и раскрытие
        корпоративного адреса электронной почты Пользователя его работодателя, в
        случае, если оплата Видеоконсультаций произошла за счет работодателя
        Пользователя, для целей составления отчетности для работодателя
        Пользователя.
      </Paragraph>

      <Paragraph>
        7.3. Исполнитель не отвечает за убытки Пользователя вследствие
        неработоспособности Сервиса или технических проблем на Сервисе, не несет
        материальной ответственности за последствия неисправностей в работе
        Сервиса для программного обеспечения Пользователя и его имущества, за
        потерю, искажение Контента, последствия хакерских и иных атак на Сервис,
        несанкционированного доступа третьих лиц к контенту, сервисам, сайту,
        иных неправомерных действий третьих лиц, действия вредоносных программ,
        сбоев в работе телекоммуникационных, энергетических сетей.
      </Paragraph>

      <Paragraph>
        7.4. Пользователь понимает, что Сервис предназначен для относительно
        здоровых людей, которые не имеют проблем со здоровьем (как физических,
        так и психологических), угрожающих жизни Пользователя или иных лиц.
        Пользователь подтверждает и гарантирует, что незамедлительно уведомит
        Специалиста о любых изменениях в его психическом и физическом
        состояниях.
      </Paragraph>

      <Paragraph>
        7.5. Исполнитель не несет ответственности за недостижение Пользователем
        ожидаемых им результатов, либо несоответствие полученного результата
        ожиданиям Пользователя.
      </Paragraph>

      <Paragraph>
        7.6. В случае нарушения Пользователем пункта 5.1.5., пункта 5.1.6. и
        пункта 5.1.7. Договора, Исполнитель имеет право в одностороннем порядке
        расторгнуть Договор и заблокировать доступ к Сервису без направления
        соответствующего уведомления Пользователю.
      </Paragraph>

      <Paragraph>
        7.7. Неудовлетворенность Пользователя результатами деятельности
        Специалиста, несоответствие результата психологической помощи его
        ожиданиям не является основанием для привлечения Исполнителя или
        Специалиста к ответственности за ненадлежащее качество оказанных услуг,
        так как психологическая помощь не имеет установленных стандартов
        правильного осуществления.
      </Paragraph>

      <Title>8. Обстоятельства непреодолимой силы (форс-мажор)</Title>

      <Paragraph>
        8.1. Стороны освобождаются от ответственности за частичное или полное
        неисполнение своих обязательств по настоящему Договору, если такое
        неисполнение стало возможным вследствие обстоятельств непреодолимой
        силы, возникших после заключения Договора в результате событий
        чрезвычайного характера, включая следующие обстоятельства (но не
        ограничиваясь ими):
      </Paragraph>

      <Paragraph>
        8.1.1. война, военные действия (независимо от того, объявлена война или
        нет), вторжение, внезапное военное нападение, действие вражеской армии,
        нации или врага.
      </Paragraph>

      <Paragraph>
        8.1.2. бунт, восстание против законной власти, гражданские волнения,
        беспорядки, восстание, организованное вооруженное сопротивление
        правительству, военный переворот, гражданская война, учения с целью
        предотвращения террористических актов, массовых беспорядков в местах
        скопления людей.
      </Paragraph>

      <Paragraph>
        8.1.3. наводнение, пожар, поджог, землетрясение, буря, удар молнии,
        обвал (оползень) или другие стихийные бедствия.
      </Paragraph>

      <Paragraph>
        8.1.4. эпидемия, болезнь, смерть, налет, саботаж, преступление, взрыв,
        террористические действия любого характера.
      </Paragraph>

      <Paragraph>
        8.1.5. выступление государственных служащих, объявление траурных дней,
        выпуск срочных сообщений или наступление иных событий, которые меняют
        программу/ выпуск СМИ.
      </Paragraph>

      <Paragraph>
        8.1.6. возникновение технического сбоя в телекоммуникационных и/или
        энергетических сетях общего пользования, действия вредоносных программ,
        а также недобросовестных действий третьих лиц, выразившихся в действиях,
        направленных на несанкционированный доступ и/или выведение из строя
        программного и/или аппаратного комплекса или наступления иного подобного
        события.
      </Paragraph>

      <Paragraph>
        8.2. Сторона, подвергшаяся воздействию обстоятельств непреодолимой силы,
        должна в течение трех (3) рабочих дней в письменной форме известить об
        этом другую Сторону, по возможности, в кратчайшие сроки, предоставив
        соответствующее подтверждение компетентных государственных или
        административных органов о наличии обстоятельств непреодолимой силы.
      </Paragraph>

      <Paragraph>
        8.3. В случае наступления форс-мажорных обстоятельств срок исполнения
        Сторонами своих обязательств по настоящему Договору отодвигается
        соразмерно времени действия обстоятельств форс-мажора.
      </Paragraph>

      <Paragraph>
        8.4. Если обстоятельства непреодолимой силы будут продолжаться более
        одного (1) месяца, то каждая из Сторон имеет право отказаться от
        дальнейшего исполнения обязательств по настоящему Договору, при условии
        возмещения другой Стороне фактически понесенных расходов.
      </Paragraph>

      <Paragraph>
        8.5. Стороны признают, что неплатежеспособность Сторон не является
        форс-мажорным обстоятельством.
      </Paragraph>

      <Title>9. Интеллектуальная собственность</Title>

      <Paragraph>
        9.1. Исключительные права на Сервис принадлежат Исполнителю.
      </Paragraph>

      <Paragraph>
        9.2. Пользователь вправе использовать Сервис по прямому функциональному
        назначению предусмотренными в рамках Сервиса способами и с обозначенными
        в настоящем Договоре запретами и ограничениями, в личных некоммерческих
        целях.
      </Paragraph>

      <Paragraph>
        9.3. Никакие положения настоящего Соглашения не предоставляют
        Пользователю право на использование фирменного наименования, товарных
        знаков, доменных имен и иных отличительных знаков Исполнителя. .
        Пользователю запрещено копировать, изменять, адаптировать, переводить,
        перепроектировать, декомпилировать или создавать любые производные
        произведения на основе Сервиса или любые материалы, включая любые файлы,
        таблицы или документацию (или их часть), пытаться восстановить исходный
        код, алгоритмы, методы или техники, извлекать материалы из базы данных
        Сайта, а также любым иным образом пытаться использовать Сайт и его
        разделы не в соответствии с его функциями. В этом случае Исполнитель
        оставляет за собой право отказать в предоставлении доступа к Сервису,
        заблокировать Личный кабинет или ограничить доступ к Личному кабинету по
        своему усмотрению, а также принять иные меры, предусмотренные
        законодательством для защиты своих прав
      </Paragraph>

      <Paragraph>
        9.4. Любое использование Сервиса кроме случаев, прямо разрешенных
        настоящим Договором, является запрещенным для Пользователя и считается
        нарушением условий Договора.
      </Paragraph>

      <Title>10. Заключительные положения</Title>

      <Paragraph>
        10.1. Договор представляет собой полную договоренность между
        Исполнителем и Пользователем.
      </Paragraph>

      <Paragraph>
        10.2. Вопросы, не урегулированные настоящим Договором, регулируются в
        соответствии с действующим законодательством Российской Федерации.
      </Paragraph>

      <Paragraph>
        10.3. Исполнитель принимает вопросы, претензии, досудебные претензии,
        пожелания, сообщения о проблемах через форму обратной связи по адресу{' '}
        <a href="mailto:prosto@pogovorim.online" rel="noreferrer">
          prosto@pogovorim.online
        </a>
        . Ответ направляется на указанный обратившимся лицом почтовый или
        электронный адрес.
      </Paragraph>

      <Paragraph>
        10.4. Все споры и разногласия, возникающие из Договора или в связи с
        ним, решаются, по возможности, посредством переговоров между сторонами.
        В случае, если стороны не придут к соглашению, то споры рассматриваются
        в порядке, установленном действующим законодательством Российской
        Федерации в районном суде города Москвы по месту нахождения Исполнителя.
        Соблюдение претензионного порядка урегулирования споров является для
        Сторон обязательным, при этом ответ на претензию не должен превышать 14
        (четырнадцать) календарных дней с даты ее получения.
      </Paragraph>

      <Paragraph>
        10.5. Договор вступает в силу с момента акцепта Пользователем настоящей
        публичной оферты и действует до полного исполнения Сторонами принятых на
        себя обязательств.
      </Paragraph>

      <Title>11. Реквизиты Исполнителя: </Title>

      <Paragraph>
        11.1. ООО «Поговорим онлайн» ИНН 9703099825, КПП 770301001, ОГРН
        1227700455795 123001, г. Москва, вн.тер. г. мун. округ Пресненский.,
        пер. Ермолаевский д. 11, помещ. III, ком. 2 Эл. почта:{' '}
        <a href="mailto:pogovorim.online@yandex.ru" rel="noreferrer">
          pogovorim.online@yandex.ru
        </a>
      </Paragraph>

      <Paragraph>
        11.2. PW TECH FZ-LLC LICENCE NO: 47006305 ADDRESS: FDRK3525 Compass
        Building, Al Shohada Road, AL Hamra Industrial ZoneFZ, Ras Al Khaimah,
        United Arab Emirates
      </Paragraph>
    </Container>

    <Container>
      <Title>
        Политика проведения платежей. Оплата банковской картой онлайн
      </Title>

      <Paragraph>
        Наш сайт подключен к интернет-эквайрингу, и Вы можете оплатить заказ
        банковской картой Visa или Mastercard прямо на сайте. После
        подтверждения выбранного заказа откроется защищенное окно с платежной
        страницей платёжного сервиса Robokassa, где Вам необходимо ввести данные
        Вашей банковской карты и адрес электронной почты для квитанции или
        фискального чека. Мы используем протокол 3D Secure для подтверждения
        оплаты. Если Ваш Банк поддерживает данный протокол, Вы будете
        перенаправлены на сервер банка для дополнительной идентификации c
        помощью SMS кода. Информацию о правилах и методах дополнительной
        идентификации уточняйте в Банке, выдавшем Вам банковскую карту.
      </Paragraph>

      <Paragraph>
        В поля на платежной странице требуется ввести номер карты, адрес
        электронной почты, срок действия карты, трёхзначный код безопасности
        (CVV2 для VISA или CVC2 для MasterCard). Все необходимые данные
        отображены на поверхности банковской карты.
      </Paragraph>

      <Paragraph>
        CVV2/ CVC2 — это трёхзначный код безопасности, находящийся на оборотной
        стороне карты.
      </Paragraph>

      <Paragraph>
        Далее в том же окне откроется страница Вашего банка-эмитента для ввода
        3-D Secure кода. В случае, если у вас не настроен статичный 3-D Secure,
        он будет отправлен на ваш номер телефона посредством SMS. Если 3-D
        Secure код к Вам не пришел, то следует обратится в ваш банк-эмитент.
      </Paragraph>

      <Paragraph>
        3-D Secure — это самая современная технология обеспечения безопасности
        платежей по картам в сети интернет. Позволяет однозначно
        идентифицировать подлинность держателя карты, осуществляющего операцию,
        и максимально снизить риск мошеннических операций по карте.
      </Paragraph>

      <br />

      <Paragraph>Случаи отказа в совершении платежа:</Paragraph>

      <Paragraph>
        В случае, если ваш платёж не прошёл или операция была отменена,
        проверьте: <br />
        —правильно ли были введены реквизиты? Обратите внимание на срок действия
        вашей карты и номер;
        <br />
        —достаточно ли средств на вашей карте? Подробнее о наличии средств на
        платежной карте Вы можете узнать, обратившись в банк, выпустивший
        банковскую карту;
        <br />
        —открыта ли возможность проведения оплат в интернете? Подробнее о
        возможностях вашей карты карты Вы можете узнать, обратившись в
        банк-эмитент;
        <br />
        —хватает ли вам ежедневного лимита на платежи в интернете? Подробнее о
        лимитах вашей карты карты Вы можете узнать, обратившись в банк-эмитент.
      </Paragraph>

      <Paragraph>
        По вопросам непрошедшей оплаты, пожалуйста обратитесь в службу поддержки
        банка эмитента, выпустившего вашу банковскую карту, или в службу
        поддержки сайта, на котором была произведена оплата.
      </Paragraph>

      <Paragraph>Гарантии безопасности</Paragraph>

      <Paragraph>
        Платёжный сервис Robokassa защищает и обрабатывает данные Вашей
        банковской карты по стандарту безопасности PCI DSS. Передача информации
        в платежный шлюз происходит с применением технологии шифрования SSL.
        Дальнейшая передача информации происходит по закрытым банковским сетям,
        имеющим наивысший уровень надежности. Robokassa не передает данные Вашей
        карты интернет магазину или третьим лицам. Для дополнительной
        аутентификации держателя карты используется протокол 3D Secure. В
        случае, если у Вас есть вопросы по совершенному платежу, Вы можете
        обратиться в службу поддержки клиентов по электронной почте{' '}
        <a href="mailto:prosto@pogovorim.online" rel="noreferrer">
          prosto@pogovorim.online
        </a>
      </Paragraph>

      <Paragraph>Безопасность онлайн платежей</Paragraph>

      <Paragraph>
        Предоставляемая Вами персональная информация (e-mail, номер банковской
        карты) является конфиденциальной и не подлежит разглашению. Данные Вашей
        банковской карты передаются только в зашифрованном виде и не сохраняются
        на нашем сервере. Безопасность обработки Интернет-платежей гарантирует
        платёжный сервис Robokassa. Все операции с платежными картами происходят
        в соответствии с требованиями VISA International, MasterCard Worldwide и
        других платежных систем. При передаче информации используется
        специальные технологии безопасности карточных онлайнплатежей, обработка
        данных ведется на безопасном высокотехнологичном сервере платёжного
        сервиса.
      </Paragraph>

      <Paragraph>
        Оплата платежными картами безопасна, потому что:
        <br />
        • Система авторизации гарантирует покупателю, что платежные реквизиты
        его платежной карты (номер, срок действия, CVV2/CVC2) не попадут в руки
        мошенников, так как эти данные не хранятся на сервере в зашифрованном
        виде и не могут быть похищены.
        <br />• Покупатель вводит свои платежные данные непосредственно в
        системе авторизации Robokassa, а не на сайте интернет-магазина,
        следовательно, платежные реквизиты карточки покупателя не будут доступны
        третьим лицам.
      </Paragraph>
    </Container>

    <Container>
      <Title>Договор публичной оферты</Title>

      <Paragraph>
        (Публичная оферта – это содержащее все существенные условия договора
        предложение, из которого усматривается воля лица, делающего предложение
        заключить договор на указанных в публичной оферте условиях с любым
        лицом, которое отзовется на это предложение в соответствии с п. 5 ст.
        395 Гражданского кодекса Республики Казахстан)
      </Paragraph>

      <Paragraph>
        Текст Договора является предложением (публичной офертой) на
        использование онлайн сервиса:{' '}
        <a href="https://pogovorim.online/" target="_blank" rel="noreferrer">
          https://www.pogovorim.online/
        </a>{' '}
        (далее – Сайт), доступ к которому предоставляет возможность получения
        услуг и пользования информационными ресурсами Администратора сайта ООО
        «Поговорим Онлайн» (далее – Администратор). Оплата услуг, размещенных на
        сайте Администратора физическим/юридическим лицом (далее – Пользователь)
        являться акцептом данной публичной оферты, что равносильно заключению
        договора (далее – Договор) на условиях, изложенных в нем. В случае, если
        Пользователь не согласен с текстом представленного Договора,
        Администратор предлагает отказаться от использования предоставляемых
        услуг.
      </Paragraph>

      <Title>1. Основные положения</Title>

      <Paragraph>
        1.1. Пользователь и Администратор заключили настоящий договор (далее –
        Договор) на получение услуг, размещенных Администратором, в соответствии
        с действующим законодательством Республики Казахстан.
      </Paragraph>

      <Paragraph>
        2.2. Термины, используемые в тексте Договора:
        <br />
        ● «Оферта» - публичное предложение на использование онлайн сервиса;
        <br />
        ● «Акцепт» - безоговорочное принятие Пользователем условий договора в
        полном объеме;
        <br />
        ● «Администратор» - сервис-провайдер, являющийся собственником сайта;
        <br />
        ● «Пользователь» - любое физическое/юридическое лицо которое принимает
        условия договора и пользуется услугами представленными на сайте
        Администратора;
        <br />
        ● «Видеоконсультация» – также онлайн консультация на Сервисе, участником
        которой является Специалист и Пользователь, на основе своей учетной
        записи через свой Личный кабинет, продолжительность которой
        устанавливается Сервисом , но не может быть менее 50 минут, если иное не
        установлено по договоренности между Пользователем и Специалистом внутри
        Сайта;
        <br />
        ● «Специалист» – физическое лицо, обладающее полной право- и
        дееспособностью, достигшее 18 лет, имеющее высшее образование или
        прошедшее переподготовку в области психологии, оказывающее помощь и
        консультирование Пользователей по различным вопросам (эмоциональные,
        личностные, социальные и т.п.) посредством Сервиса, без выписывания
        медицинских рецептов.
        <br />● «Сайт» - совокупность программных средств, обеспечивающих
        публикацию для всеобщего обозрения информации и данных, объединенных
        общим целевым назначением, посредством технических средств. Сайт
        доступен Пользователям по уникальному электронному адресу или его
        буквенному обозначению. Под Сайтом в Соглашении понимается Сайт
        Администрации, расположенный в сети Интернет по адресу{' '}
        <a href="https://pogovorim.online/" target="_blank" rel="noreferrer">
          https://www.pogovorim.online/
        </a>
      </Paragraph>

      <Title>2. Предмет оферты</Title>

      <Paragraph>
        2.1. Предметом Договора является предоставление Администратором
        Пользователю доступа к функциональным возможностям Сервиса, позволяющим
        осуществить выбор Специалиста, а также проведения Видеоконсультаций со
        Специалистом по вопросу индивидуальной психологиче ской работы с
        Пользователем. При этом Видеоконсультацию Пользователю проводит
        непосредственно Специалист, а Администратор только предоставляет
        техническую возможность использования функциональных возможностей Сайта.
      </Paragraph>

      <Paragraph>
        2.2. Администратор обязуется оказывать техническое обслуживание и
        поддержку Сайта.
      </Paragraph>

      <Paragraph>
        2.3. Действующая редакция Договора находится на Сайте в публичном
        доступе по адресу:{' '}
        <a
          href="https://pogovorim.online/documents/public-offer-user"
          target="_blank"
          rel="noreferrer"
        >
          https://www.pogovorim.online/documents/public-offer-user
        </a>
      </Paragraph>

      <Title>3. Использование онлайн сервиса</Title>

      <Paragraph>
        3.1. Для получения Видеоконсультации на Сайте Пользователь по своему
        желанию выбирает тарифный план, проводит регистрацию путем
        предоставления персональных данных и производит оплату.
      </Paragraph>

      <Paragraph>
        3.2. Оплата Пользователя означает безоговорочное и полное согласие с
        условиями Договора. День оплаты Пользователем Услуг считается днем
        заключения Договора на срок указанный в пакете услуг.
      </Paragraph>

      <Paragraph>
        3.3. Ни Администратор, ни Специалист не оказывают медицинские услуги, не
        занимаются выдачей каких-либо сертификатов или рецептов, а также не
        осуществляют назначение медицинских препаратов. Исполнитель и Специалист
        не занимаются лечебной или какой-либо другой медицинской практикой.
      </Paragraph>

      <Paragraph>
        3.4. Пользователь полностью осознает, что Администратор ни при каких
        условиях не может нести и не несет ответственность за результат
        проведения Видеоконсультаций.
      </Paragraph>

      <Paragraph>
        3.6. В случае, если Видеоконсультация не состоялась по вине Специалиста
        и/или Специалист уведомил Пользователя об отмене или переносе
        Видеоконсультации не позже чем за 24 часа, то, на усмотрение
        Пользователя, оплаченная за Видеоконсультацию сумма, либо подлежит
        возврату Пользователю, либо засчитывается в счет оплаты следующей
        Видеоконсультации.
      </Paragraph>

      <Paragraph>
        3.7 Особенностью исполнения договорных обязательств является отсутствие
        гарантированного результата, так как полезный эффект зависит не только
        от профессионализма Специалиста, но и от личных качеств Пользователя
      </Paragraph>

      <Title>
        4. Регистрация на сайте, конфиденциальность и защита персональных данных
      </Title>

      <Paragraph>
        4.1. Персональные данные содержат в себе следующую информацию:
        <br />
        ● Имя Пользователя;
        <br />
        ● Пароль и логин для входа в личный кабинет;
        <br />● Телефон и/или адрес электронной почты.
      </Paragraph>

      <Paragraph>
        4.2. При необходимости Пользователь имеет право редактировать внесенные
        данные о себе в личном кабинете.
      </Paragraph>

      <Paragraph>
        4.3. Администратор обязуется не разглашать полученную от Пользователя
        информацию. Не считается нарушением обязательств разглашение информации
        в соответствии с обоснованными требованиями, согласно действующему
        законодательству Республики Казахстан.
      </Paragraph>

      <Paragraph>
        4.4. Пользователь несет ответственность за все действия и последствия
        использования личного кабинета, за добровольную передачу доступа к
        своему личному кабинету третьим лицам, а также за несанкционированный
        доступ. Все перечисленные действия будут считаться произведенными самим
        Пользователем.
      </Paragraph>

      <Title>5. Права и обязанности сторон</Title>

      <Paragraph>
        5.1. Администратор:
        <br />
        ● Обязуется оказывать техническую поддержку и предоставлять полную
        информацию по работе Сайта.
        <br />
        ● Обязуется не разглашать персональные данные Пользователя;
        <br />
        ● Не несет ответственность в связи с информацией, предоставленной
        Пользователем.
        <br />● Имеет право в одностороннем порядке изменять условия
        предоставления Услуг и вносит изменения в редакцию Договора.
      </Paragraph>

      <Paragraph>
        5.2. Пользователь:
        <br />
        ● Несет полную ответственность за правильность информации, введенной при
        регистрации на Сайте Администратора, а также за несвоевременное
        представление изменений в регистрационные данные;
        <br />
        ● Несет личную ответственность за любые действия, совершенные с
        использованием своего личного кабинета, а также за любые последствия,
        которые могло повлечь или повлекло такое использование третьими лицами
        при ненадлежащем хранении Пользователем логина и пароля.
        <br />● Имеет право пользоваться услугами Сайта в своих интересах,
        непосредственно не вмешиваясь в его работу.
      </Paragraph>

      <Title>6. Порядок оплаты</Title>

      <Paragraph>
        6.1. Оплата производится на счет Администратора банковскими картами или
        иными безналичными способами после проведения регистрации по следующим
        тарифным планам (пакетам Услуг):
      </Paragraph>

      <Paragraph>
        6.2. Услуги предоставляются при условии 100% предоплаты, тестовые
        периоды не предоставляются.
      </Paragraph>

      <Paragraph>
        6.3. Администратор самостоятельно контролирует срок истечения
        предоставления Услуг.
      </Paragraph>

      <Paragraph>
        6.4. За правильность платежей ответственность лежит на Пользователе.
      </Paragraph>

      <Title>7. Ответственность сторон, разрешение споров</Title>

      <Paragraph>
        7.1. За неисполнение или ненадлежащее исполнение своих обязательств
        Стороны несут ответственность в соответствии с действующим
        законодательством Республики Казахстан.
      </Paragraph>

      <Paragraph>
        7.2. Все споры, возникающие между Сторонами при исполнении настоящей
        Оферты, разрешаются путем мирных переговоров, а в случае не достижения
        согласия между Сторонами, спор рассматривается в судебном порядке в
        соответствии с действующим законодательством Республики Казахстан в
        арбитражном суде по месту регистрации Администратора.
      </Paragraph>

      <Title>8. Срок действия договора и его расторжение</Title>

      <Paragraph>
        8.1. Публичная оферта вступает в силу с момента акцепта Оферты и
        действует в течение срока предоставления доступа к Сайту Администратора.
      </Paragraph>

      <Paragraph>
        8.2. Администратор имеет право блокировать доступ к серверу в следующих
        случаях:
        <br />
        ● При получении распоряжений государственных органов Республики
        Казахстан;
        <br />
        ● При нарушении авторских и смежных прав;
        <br />
        ● При мотивированном обращении третьих лиц при нарушении их прав;
        <br />● При обнаружении запрещенной законодательством информации,
        размещенной Пользователем.
      </Paragraph>

      <Paragraph>
        8.3. Пользователь имеет право отказаться от пользования предоставленными
        Услугами. Отказ от Услуг принимается в течение 14 (четырнадцати)
        календарных дней с даты получения доступа к Сайту путем направления
        письменного заявления от Пользователя на e-mail Администратора с
        объяснением реальных мотивированных причин отказа. В случае нарушения
        срока в течение, которого возможен отказ, претензии от Пользователя не
        принимаются.
      </Paragraph>

      <Paragraph>
        8.4. Возврат денежных средств производится Администратором за минусом
        денежной суммы за фактически оказанные Услуги в течение 14
        (четырнадцати) календарных дней на реквизиты Пользователя, указанные в
        заявлении после подтверждения Администратором мотивированных причин
        отказа от Услуг.
      </Paragraph>

      <Paragraph>
        8.5. В случае нарушений условий Договора предоплаченные денежные
        средства не возвращаются.
      </Paragraph>

      <Title>9. Прочие условия</Title>

      <Paragraph>
        9.1. Администратор имеет право в одностороннем порядке изменить условия
        Договора в целом или в его части без согласования с Пользователем. В
        общем доступе на Сайте публикуется действующая редакция.
      </Paragraph>

      <Paragraph>
        9.2. Данная версия настоящего Договора является текущей и отменяет
        предыдущую версию.
      </Paragraph>

      <Paragraph>
        9.3. Стороны освобождаются от ответственности за неисполнение или
        ненадлежащее исполнение условий настоящего Договора на время действий
        непреодолимой силы. К ним относятся такие события как: стихийные
        природные явления, военные действия, массовые беспорядки, а также
        принятие государственными органами законодательных актов, препятствующих
        выполнению условий настоящего Договора. В этом случае выполнение
        обязательств двумя Сторонами откладывается на время действия
        обстоятельств непреодолимой силы и их последствий.
      </Paragraph>

      <Paragraph>
        9.4. Во всем остальном, что не предусмотрено условиями настоящего
        Договора, Стороны руководствуются действующим законодательством
        Республики Казахстан.
      </Paragraph>

      <Title>Реквизиты исполнителя</Title>

      <Paragraph>
        ТОО «Помогаем онлайн»
        <br />
        Адрес: 050018, Республика Казахстан, Алматы, Жетысуский район, улица
        Жангельдина, дом 52/40, квартира 1<br />
        БИН/ИИН: 231140007367
        <br />
        Р/c: KZ298562203134230575
        <br />
        БИК: KCJBKZKX
        <br />
        АО {'"'}Банк ЦентрКредит{'"'}
        <br />
        Контактный email:{' '}
        <a href="mailto:prosto@pogovorim.online" rel="noreferrer">
          prosto@pogovorim.online
        </a>
      </Paragraph>
    </Container>
  </>
);

export default PublicUserOffer;

const Background = styled.div`
  width: 100%;
  background: #f4f4f4;
  padding: 50px 0 50px;
  @media (max-width: ${BreakpointsEnum.lgm}px) {
    padding: 0;
  }
`;

const Container = styled.div`
  background: #fff;
  margin: 10px auto 40px;
  padding: 60px 40px;
  width: 100%;
  max-width: 900px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.09);
  @media (max-width: ${BreakpointsEnum.lgm}px) {
    max-width: 96%;
    padding: 30px 24px;
  }
`;

const PageTitle = styled.h1`
  width: 100%;
  font-size: 20px;
  text-align: center;
  margin-bottom: 40px;
`;

const Title = styled.h2`
  width: 100%;
  margin: 30px 0 10px;
  font-size: 18px;
  text-align: center;
`;

const Paragraph = styled.p`
  margin: 20px 0 20px;
  font-size: 16px;
  line-height: 22px;
`;

const AfterPageTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
